<template>
    <div style="background-color: #eeeeee;padding-bottom: 100px;">
        <img src="../../assets/banner6.png" alt="">
        <div class="main">
            <!-- <Breadcrumb /> -->
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">首页</li>
                <li>></li>
                <li>销售与代理商</li>
            </ul>
            <div class="content">
                <!-- <div class="menu">
                    <Menu :active="'0'" />
                </div> -->
                <div class="apply">
                    <h3 class="tab_title">销售咨询</h3>
                    <table border="1">
                        <tr>
                            <th>地区</th>
                            <th>电话</th>
                            <th>微信</th>
                            <th>邮箱</th>
                        </tr>
                        <tr v-for="item in saleList">
                            <td>
                                <div class="ql-editor" v-html="item.name"></div>
                            </td>
                            <td>
                                <div class="ql-editor" v-html="item.phone"></div>
                            </td>
                            <td>{{ item.wx }}</td>
                            <td>{{ item.email }}</td>
                        </tr>
                    </table>
                    <h3 class="tab_title">代理人咨询</h3>
                    <table border="1">
                        <tr>
                            <th width="300">代理商</th>
                            <th width="160">联系人</th>
                            <th>电话/邮箱</th>
                            <th width="300">网址</th>
                        </tr>
                        <tr v-for="item in list">
                            <td :rowspan="item.rowspan">
                                <div class="ql-editor" v-html="item.name"></div>
                            </td>
                            <td>
                                <div class="ql-editor" v-html="item.linkPerson"></div>
                                <!-- {{ item.linkPerson }} -->
                            </td>
                            <td>
                                <div class="ql-editor" v-html="item.phone"></div>
                            </td>
                            <td>{{ item.web }}</td>
                        </tr>
                    </table>
                    <h3 class="tab_title">在线购买</h3>
                    <table border="1">
                        <tr>
                            <th>网上商城</th>
                            <th>网址</th>
                        </tr>
                        <tr v-for="item in urlList">
                            <td :rowspan="item.rowspan">
                                <div class="ql-editor" v-html="item.name"></div>
                            </td>
                            <td><a target='_blank' style='cursor: pointer; color:#426c9b;text-decoration:underline;' :href="item.web">{{ item.web }}</a></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Menu from './menu/index.vue'
import { getMarketList } from '@/api/index'
import {backPage} from '@/utils/common'
export default {
    components: {
        Menu
    },
    data() {
        return {
            saleList: [],
            list: [],
            urlList:[]
        }
    },
    mounted() {
        getMarketList({ type: "1" ,pageSize:100}).then(res => {
            this.saleList = res.rows
        })
        getMarketList({ type: "2",pageSize:100 }).then(res => {
            let rows = res.rows
            console.log(rows);
            this.list = res.rows
        })
        getMarketList({ type: "3",pageSize:100 }).then(res => {
            this.urlList = res.rows
        })
    },
    methods:{
        backPage,
    }
}
</script>
<style lang="scss" scoped>
.content {
    display: flex;

    .menu {
        width: 250px;
    }

    .apply {
        flex: 1;
        // margin-left: 30px;
    }
}

table,
td,
th {
    text-align: center;
    border: 1px solid #cbcbcb;
    border-collapse: collapse;
    p {
        margin-bottom: 10px;
    }
}

table {
    width: 100%;
    margin-bottom: 60px;
}

table td {
    line-height: 40px;
}

th {
    background-color: #d7d7d7;
    color: #2f2f2f;
    line-height: 50px;

}

td {
    background-color: #fff;
    color: #2d2d2d;

    * {
        text-align: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/fwzc/xsydls.vue